import { useState } from 'react';
import { SocialLinksConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';

interface Props {
  data: SocialLinksConfig;
  onChange: (data: SocialLinksConfig) => void;
}

const fields: { key: keyof SocialLinksConfig; label: string; icon: string; placeholder: string }[] = [
  { key: 'instagram', label: 'Instagram', icon: 'ri-instagram-line', placeholder: 'https://instagram.com/hesabiniz' },
  { key: 'facebook', label: 'Facebook', icon: 'ri-facebook-circle-line', placeholder: 'https://facebook.com/sayfaniz' },
  { key: 'youtube', label: 'YouTube', icon: 'ri-youtube-line', placeholder: 'https://youtube.com/@kanaliniz' },
  { key: 'twitter', label: 'X (Twitter)', icon: 'ri-twitter-x-line', placeholder: 'https://x.com/hesabiniz' },
  { key: 'whatsapp', label: 'WhatsApp Numarası', icon: 'ri-whatsapp-line', placeholder: '905001234567' },
];

export default function SocialSection({ data, onChange }: Props) {
  const [local, setLocal] = useState<SocialLinksConfig>(data);
  const [saved, setSaved] = useState(false);

  const update = (key: keyof SocialLinksConfig, value: string) => {
    setLocal(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    onChange(local);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Sosyal Medya Linkleri</h2>
        <p className="text-xs text-stone-400">Boş bırakılan platformlar footer'da gösterilmez.</p>

        {fields.map(f => (
          <div key={f.key}>
            <label className="flex items-center gap-2 text-xs font-medium text-stone-600 mb-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={f.icon} />
              </div>
              {f.label}
            </label>
            <input
              type="text"
              value={local[f.key]}
              onChange={e => update(f.key, e.target.value)}
              placeholder={f.placeholder}
              className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
            />
          </div>
        ))}
      </div>

      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
